import { SafeImg } from './ScrollReveal';

const cards = [
  {
    image: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20manhwa%20style%20romance%20illustration%20with%20soft%20pink%20and%20warm%20peach%20tones%2C%20two%20characters%20in%20a%20cozy%20cafe%20setting%2C%20gentle%20atmosphere%2C%20clean%20editorial%20composition%2C%20no%20text&width=600&height=400&seq=card-01&orientation=landscape',
    tag: '编辑精选',
    title: '2024年度最受欢迎韩漫TOP10',
    desc: '综合阅读量、收藏数和评分，我们整理出今年最值得看的十部韩漫佳作。',
    meta: '12月26日',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=A%20dynamic%20Japanese%20manga%20style%20action%20scene%20with%20warm%20orange%20and%20red%20energy%20effects%2C%20epic%20battle%20atmosphere%2C%20dramatic%20lighting%2C%20clean%20editorial%20composition%2C%20no%20text&width=600&height=400&seq=card-02&orientation=landscape',
    tag: '新番速递',
    title: '一月日漫新番原作漫画抢先看',
    desc: '动画化决定！这些即将登上荧幕的原作漫画现在就可以在99漫画在线阅读。',
    meta: '1月5日',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Chinese%20manhua%20style%20fantasy%20scene%20with%20traditional%20elements%2C%20flowing%20ink%20brush%20style%2C%20warm%20gold%20and%20red%20accents%2C%20ancient%20Chinese%20aesthetic%2C%20clean%20editorial%20composition%2C%20no%20text&width=600&height=400&seq=card-03&orientation=landscape',
    tag: '国漫专题',
    title: '国漫崛起：那些不输日韩的精品',
    desc: '从画风到剧情全面解析，这些国漫真的是越做越好，完全不输日韩作品。',
    meta: '12月20日',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=A%20mysterious%20dark%20fantasy%20illustration%20with%20warm%20glowing%20accents%2C%20dungeon%20exploration%20theme%2C%20atmospheric%20lighting%20with%20shadows%20and%20warm%20highlights%2C%20clean%20editorial%20composition%2C%20no%20text&width=600&height=400&seq=card-04&orientation=landscape',
    tag: '阅读指南',
    title: '系统流漫画入坑指南',
    desc: '从《我独自升级》到各类系统流神作，一文带你了解这个最火热的漫画类型。',
    meta: '11月30日',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=A%20cozy%20manga%20reading%20scene%20with%20warm%20ambient%20lighting%2C%20digital%20tablet%20displaying%20colorful%20comic%20pages%2C%20soft%20cream%20and%20coral%20color%20palette%2C%20comfortable%20atmosphere%2C%20clean%20editorial%20composition%2C%20no%20text&width=600&height=400&seq=card-05&orientation=landscape',
    tag: '使用技巧',
    title: '99漫画APP隐藏功能大揭秘',
    desc: '离线缓存、阅读模式切换、书签管理……你未必知道的五大实用功能全攻略。',
    meta: '11月18日',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 text-xs font-semibold rounded-full bg-primary-100 text-primary-700 mb-3 whitespace-nowrap">
            精选内容
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            编辑推荐
          </h2>
          <p className="mt-2 text-sm text-foreground-500 max-w-md mx-auto">
            编辑团队精心策划的漫画专题与阅读指南
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5">
          {cards.map((card, i) => (
            <a
              key={i}
              href="#cards"
              className="group block bg-background-50 rounded-lg border border-background-200/70 overflow-hidden hover:border-primary-200 transition-all duration-200 cursor-pointer"
            >
              <div className="relative h-40 overflow-hidden">
                <SafeImg
                  src={card.image}
                  alt={card.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <span className="absolute top-2 left-2 px-2 py-0.5 text-xs font-semibold rounded bg-accent-500/90 text-background-50 whitespace-nowrap">
                  {card.tag}
                </span>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-bold text-foreground-900 mb-1.5 group-hover:text-primary-500 transition-colors line-clamp-2">
                  {card.title}
                </h3>
                <p className="text-xs text-foreground-600 leading-relaxed line-clamp-2 mb-2">
                  {card.desc}
                </p>
                <span className="text-xs text-foreground-400">{card.meta}</span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}